import { useMemo } from "react";
import { DeviceProvider } from "@/react/components/shared/BuilderUI/DeviceProvider";
import { formBlocks } from "@/react/components/SettingsApp/Emails/components/Forms/VisualFormsBuilder/blocks";
import { formToBlocks } from "@/react/components/SettingsApp/Emails/components/Forms/VisualFormsBuilder/blocks/shared/formToBlocks";
import { EndingPage } from "@/react/components/SettingsApp/Emails/components/Forms/VisualFormsBuilder/components/Ending/EndingPage";
import { BlocksContextProvider } from "@/react/components/SettingsApp/Emails/components/Forms/VisualFormsBuilder/contexts/BlocksContext";
import { createBlockRendererMapping } from "@circle-react-shared/BuilderUI/Helpers/blockMappings";
import { BlockRenderer } from "@circle-react-shared/BuilderUI/Renderer/BlockRenderer";
import { SITE_THEMES } from "@circle-react-shared/BuilderUI/SiteThemes/constants";
import { UserThemeManager } from "@circle-react-shared/BuilderUI/ThemeManager/UserThemeManager";
import "@circle-react-shared/BuilderUI/styles/builder-ui.css";
import { useFormRenderingContext } from "../contexts/FormRenderingContext";
import { FormWrapper } from "./FormWrapper";

export const FormContent = () => {
  const { form, isModal, titleElement, shouldRenderEndingPage, isUsedOnPages } =
    useFormRenderingContext();
  const formBlock = useMemo(
    () => formToBlocks(form, isModal ? titleElement : undefined),
    [form, isModal, titleElement],
  );
  const components = createBlockRendererMapping(formBlocks);
  return (
    <UserThemeManager theme={SITE_THEMES.default_theme.cssVariables}>
      <FormWrapper>
        <BlocksContextProvider
          useFormRenderingContext={useFormRenderingContext}
        >
          {shouldRenderEndingPage ? (
            <EndingPage isModal={isModal} isUsedOnPages={isUsedOnPages} />
          ) : (
            <DeviceProvider>
              <BlockRenderer block={formBlock} components={components} />
            </DeviceProvider>
          )}
        </BlocksContextProvider>
      </FormWrapper>
    </UserThemeManager>
  );
};
